import { sql } from 'drizzle-orm'
import {
    index,
    integer,
    snakeCase,
    text,
    timestamp,
    uniqueIndex,
    varchar,
} from 'drizzle-orm/pg-core'
import { id, timestamps } from '../utils/columns.helpers'
import { benefitsTable } from './benefits.table'
import { clientsTable } from './clients.table'
import { usersTable } from './users.table'

export const benefitRecentTable = snakeCase.table(
    'benefit_recents',
    {
        id: id('br'),
        benefitId: text()
            .notNull()
            .references(() => benefitsTable.id, {
                onDelete: 'cascade',
                onUpdate: 'cascade',
            }),
        userId: text().references(() => usersTable.id, {
            onDelete: 'cascade',
            onUpdate: 'cascade',
        }),
        clientId: text().references(() => clientsTable.id, {
            onDelete: 'cascade',
            onUpdate: 'cascade',
        }),
        sessionId: varchar({ length: 128 }),
        viewCount: integer().notNull().default(1),
        interactionType: varchar({ length: 32 }).notNull().default('view'),
        lastViewedAt: timestamp({ withTimezone: true }).notNull().defaultNow(),
        ...timestamps,
    },
    (table) => [
        // Atomic Upsert constraint to eliminate race conditions
        uniqueIndex('benefit_recents_user_benefit_unique')
            .on(table.userId, table.benefitId)
            .where(sql`user_id IS NOT NULL`),

        // High-performance feed query index (Covering user's recent deals with zero sorting cost)
        index('benefit_recents_user_last_viewed_idx').on(
            table.userId,
            table.lastViewedAt,
        ),

        // Organization/Client aggregate query index
        index('benefit_recents_client_last_viewed_idx').on(
            table.clientId,
            table.lastViewedAt,
        ),

        // Foreign key cascade helper index
        index('benefit_recents_benefit_idx').on(table.benefitId),
    ],
)
